const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export { API_ENDPOINT };
